import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './lib/auth.js';
import { ConfirmProvider } from './lib/Modal.js';
import '@fontsource-variable/plus-jakarta-sans';
import './styles.css';
import { initTheme } from './lib/theme.js';

initTheme();

/**
 * Take a new deploy when the app comes back from a long sleep.
 *
 * Navigations are network-first, so a cold start always gets the current build — but the app's
 * WebView is not restarted when somebody switches back to it, and a phone that is never fully
 * closed can run the code it was opened with for days. The office deploys a fix, the employee is
 * told it is there, and their screen goes on looking exactly as it did.
 *
 * Fifteen minutes in the background is long enough that a reload costs nothing anybody is in the
 * middle of, and short enough that a morning's deploy is on the floor by the afternoon.
 */
const STALE_AFTER_MS = 15 * 60 * 1000;
let hiddenSince: number | null = null;
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    hiddenSince = Date.now();
    return;
  }
  const away = hiddenSince ? Date.now() - hiddenSince : 0;
  hiddenSince = null;
  if (away > STALE_AFTER_MS) location.reload();
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* push/offline features unavailable; the app still works */
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
